export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "labels": {
          "go_back_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Volver a la lista de procesos"])},
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Contenedores"])},
          "manage_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gestionar"])},
          "total_number_containers": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Contenedores"])}
        }
      },
      "en": {
        "labels": {
          "go_back_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Go back to list of process"])},
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Containers"])},
          "manage_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Manage"])},
          "total_number_containers": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Containers"])}
        }
      }
    }
  })
}